export const DANGER = {
  DARKER: '#8c0005',
  DARK: '#b8000e',
  DEFAULT: '#dc1f30',
  LIGHT: '#fc7c78',
  LIGHTER: '#ffbfb9',
  LIGHTEST: '#ffe1db',
} as const;
